export default __webpack_public_path__ + "static/3_Screenshot-b5655178258fb548c913bd280df7d34b.png";